/* eslint-disable @typescript-eslint/no-explicit-any*/
import { ProgressionState } from '../redux/reducers/progression';
import {
  Skill,
  TagText,
  SFFProblemType,
  ProblemOptionId,
  Scenario,
  PageType,
  ProblemStage,
  HintsDefinition
} from 'its-pages';

export type TraitID = string;
export type ExemplarID = string;

export interface Curriculum {
  name: string;
  version: string;
}

// export interface ModuleSkill {
//   name: string;
// }
export interface ModuleInfo {
  skill: Skill;
  curriculum: Curriculum;
  progression: Progression;
}

export interface ActivityStart {
  cid: string;
  activityId: string;
  moduleInfo: ModuleInfo;
  savedUserState: SavedUserState;
  noLogging: boolean;
}

export enum TraitQuality {
  Good,
  Bad
}

export interface Trait {
  id: TraitID;
  importance: number;
  quality: TraitQuality;
  description: string;
}

export interface Problem {
  title: string;
}

export interface Content {
  scenarios: Scenario[];
}

export interface BannerInfo {
  nextSkill: string;
}

export type PageInfo = null | BannerInfo;

export interface PageDescription {
  contentType: ContentType;
  pageType: PageType;
  pageInfo: PageInfo;
  /**
   * Not sure why this is an array, just seems to indicate number of sub-levels a question type has
   * For example [2] for a question type means that type has 3 difficulty levels
   */
  subs: number[];
}

export type Progression = PageDescription[];

export enum ContentType {
  ModuleIntro = 'P0',
  Type1 = 'P1',
  Type2 = 'P2',
  Type3 = 'P3',
  Type4 = 'P4',
  Type5 = 'P5',
  Type6 = 'P6',
  Type7 = 'P7',
  Discourse = 'Discourse',
  DiscourseFixed = 'DiscourseFixed',
  TagAnnotation = 'TagAnnotation',
  AnnotateSingle = 'AnnotateSingle',
  AnnotateMulti = 'AnnotateMulti',
  FixedOption = 'FixedOption',
  SelfEval = 'SelfEval',
  PeerEval = 'PeerEval',
  ModuleCompletion = 'ModuleCompletion'
}

export interface ProblemProps {
  description: TagText | string;
  scenario: Scenario;
  problemType: string;
  type: SFFProblemType;
  moveOnToNextProblem: () => void;
  setStage: (stage: ProblemStage) => void;
  hints: HintsDefinition[];
  skill: Skill;
  problemQuality: boolean;
  stage: ProblemStage;
}

export const toSFFProblemType: { [type in ContentType]: SFFProblemType } = {
  [ContentType.ModuleIntro]: SFFProblemType.ModuleIntro,
  [ContentType.Type1]: SFFProblemType.Type1,
  [ContentType.Type2]: SFFProblemType.Type2,
  [ContentType.Type3]: SFFProblemType.Type3,
  [ContentType.Type4]: SFFProblemType.Type4,
  [ContentType.Type5]: SFFProblemType.Type5,
  [ContentType.Type6]: SFFProblemType.Type6,
  [ContentType.Type7]: SFFProblemType.Type7,
  [ContentType.Discourse]: SFFProblemType.Discourse,
  [ContentType.DiscourseFixed]: SFFProblemType.DiscourseFixed,
  [ContentType.TagAnnotation]: SFFProblemType.TagAnnotation,
  [ContentType.AnnotateSingle]: SFFProblemType.AnnotateSingle,
  [ContentType.SelfEval]: SFFProblemType.SelfEval,
  [ContentType.PeerEval]: SFFProblemType.PeerEval,
  [ContentType.AnnotateMulti]: SFFProblemType.AnnotateMulti,
  [ContentType.ModuleCompletion]: SFFProblemType.ModuleCompletion,
  [ContentType.FixedOption]: SFFProblemType.FixedOption
};

export interface Difficulty {
  main: number;
  secondary: number;
}

export interface ContentSetup {
  moduleInfo: ModuleInfo;
  progressionIndex: number;
  difficulty: Difficulty;
  scenario: Scenario | undefined;
  seed: number | undefined;
}

export function isTagText(object: any): object is TagText {
  return 'imperative' in object;
}

export type NextProblem = () => void;

export interface ResponseItem {
  id: ProblemOptionId;
  selected: boolean;
  idx: number;
}

export interface ConstructResponse {
  id: ProblemOptionId;
  selected: boolean;
  idx: number;
}

export interface SelectResponse {
  id: ProblemOptionId;
  value: string;
}

export interface QualityResponse {
  id: ProblemOptionId;
  quality: number;
}

export interface InputProblemResponse {
  // setup: ContentSetup;
  responses: ResponseItem[];
}

export interface SelectProblemResponse {
  setup: ContentSetup;
  responses: SelectResponse[];
}

export interface ConstructProblemResponse {
  setup: ContentSetup;
  responses: ConstructResponse[];
}

export interface EvaluatedResponse {
  setup: ContentSetup;
  score: number;
  validOptions: ProblemOptionId[];
  progress: number;
  responseTime: number;
}

export interface ScoredOption {
  validOptions: ProblemOptionId[];
  score: number;
}

export interface ProblemSetupState {
  progressionIndex: number;
  difficulty: Difficulty;
}
export interface ModuleState {
  problemSetupState: ProblemSetupState;
  progression: ProgressionState;
}

export interface SavedUserState {
  stateVersion?: number;
  moduleState: ModuleState;
}

export interface ProgressLoaded {
  moduleState: ModuleState;
  moduleInfo: ModuleInfo;
}

export interface StringMap {
  [key: string]: string;
}
